import moment from 'moment'

import {DateTimeSubFieldNames, DateTimeForm} from '.'

export const isDateTimeDirty = (
  fieldPart: DateTimeSubFieldNames['fieldPart'],
  fieldValue: DateTimeForm['dateTime'],
  defaultValue?: DateTimeForm['dateTime']
) => {
  const defaultOrderDateTime = defaultValue?.[0]
  const fieldOrderDateTime = fieldValue[0]

  if (fieldPart === 'date') {
    // Check only if date is changed
    const defaultDate = moment(defaultOrderDateTime || 0).format('YYYY-MM-DD')
    const fieldDate = moment(fieldOrderDateTime || 0).format('YYYY-MM-DD')
    return defaultDate !== fieldDate
  } else if (fieldPart === 'time') {
    // Check only if time is changed
    const defaultTime = moment(defaultOrderDateTime || 0).format('LT')
    const fieldTime = moment(fieldOrderDateTime || 0).format('LT')
    return defaultTime !== fieldTime
  } else {
    const defaultDate = moment(defaultOrderDateTime || 0).toISOString()
    const fieldDate = moment(fieldOrderDateTime || 0).toISOString()
    return defaultDate !== fieldDate
  }
}
